import {IDeepLinkActionsFactoryService} from "../../deep-link-action-factory/deep-link-actions-factory.service.inteface";
import {ICasinoDeepLinkAction} from "../../casino-deep-link-action.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {decodeUriComponentRecursive} from "../../../../../utils/url-utils";
import {DEEP_LINK_HASH_PARAM} from "../../deeplink-consts";
import {UnifiedDeepLinkAction} from "./unified-deep-link-action";

export class DeepLinkActionsFactoryUnifiedStrategy implements IDeepLinkActionsFactoryService {
    constructor(private readonly services: IServiceFactoryExtended) {
    }

    createActionFromCurrentRoute(): ICasinoDeepLinkAction | null {
        const jsonObject = this._extractDeepLinkJsonFromHash();
        return this.createActionFromDeepLinkObject(jsonObject);
    }

    private _extractDeepLinkJsonFromHash(): any {
        let hash = this.services.location.currentUri.hash.value;
        if(!hash) {
            return null;
        }

        hash = decodeUriComponentRecursive(hash);

        if(hash.indexOf(DEEP_LINK_HASH_PARAM) !== 0) {
            return null;
        }

        hash = hash.replace(DEEP_LINK_HASH_PARAM, '');

        try {
            return JSON.parse(hash);
        } catch (err) {
            this.services.logger.error(`Invalid unified deeplink format ${hash}`, err);
            return null;
        }

    }

    createActionFromDeepLinkObject(deepLinkObject: any): ICasinoDeepLinkAction | null {
        if(deepLinkObject?.actions) {
            return new UnifiedDeepLinkAction(this.services, deepLinkObject);
        }

        return null;
    }

}